document.addEventListener('click', (e) => {
    if (e.target.classList.contains('tab')) {
        const tab = e.target
        const tabs = document.querySelectorAll('.tab')
        const tabContents = document.querySelectorAll('.tab-content')

        tabs.forEach((tab) => {
            tab.classList.remove('active')
        })
        tab.classList.add('active')

        // Hämta sökparametrar från aktuell sida

        // Spara tab-värdet i localStorage
        localStorage.setItem('active_mfn_tab', tab.dataset.mfn_tab)

        tabContents.forEach((tabContent) => {
            tabContent.classList.remove('active')

            if (tabContent.dataset.mfn_tab === tab.dataset.mfn_tab) {
                tabContent.classList.add('active')
            }
        })

        if (window.location.search !== '') {
            window.location.search = ''
        }
    }
})

// Hämta tab-värdet från localStorage på dom ready och lägg till active klassen på rätt tab men ta först bort active klassen från alla tabs
document.addEventListener('DOMContentLoaded', () => {
    let active_mfn_tab = localStorage.getItem('active_mfn_tab')
    const allTabs = document.querySelectorAll('[data-mfn_tab]')
    if (active_mfn_tab) {
        allTabs.forEach((tab) => {
            tab.classList.remove('active')
        })
        // Remove the `const` keyword so you are assigning to the existing variable.
        active_mfn_tab = document.querySelectorAll(`[data-mfn_tab="${active_mfn_tab}"]`)
        active_mfn_tab.forEach((tab) => {
            tab.classList.add('active')
        })
    } else {
        allTabs.forEach((tab) => {
            if (tab.classList.contains('tab') && !document.querySelector('.tab.active')) {
                tab.classList.add('active')
            }

            if (tab.classList.contains('tab-content') && !document.querySelector('.tab-content.active')) {
                tab.classList.add('active')
            }
        })
    }
})
